import 'core-js/stable';
import 'regenerator-runtime/runtime';
import axios from 'axios';
import VueAxios from 'vue-axios';
import * as Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars, faTimes, faChevronDown, faSearch, faPlay, faSpinner
} from '@fortawesome/free-solid-svg-icons';
import { initMenuMain } from './menu/menu-main';
import { initMobileSecondary } from './menu/menu-mobile-secondary';
import { initShieldedSite } from './footer/shielded-site';
import VideoBlock from './components/VideoBlock.vue';
import Accordion from './components/Accordion.vue';
import Applications from './components/Applications.vue';
library.add(faBars);
library.add(faTimes);
library.add(faChevronDown);
library.add(faSearch);
library.add(faPlay);
library.add(faSpinner);

const app = Vue.createApp({
  components: {
    FontAwesomeIcon,
    VideoBlock,
    Accordion,
    Applications
  },
  mounted() {
    initMenuMain();
    initMobileSecondary();
    initShieldedSite();
  }
});

app.use(VueAxios, axios);
app.mount('#app');